'use strict';
define([], function () {
    /* One exam row of the SEO report: status, title, two-line summary and the
       expandable detail (how to fix it, what was found, the affected pages).
       Shared by the Issues section and the project overview. */
    return {
        templateUrl: 'app/modules/project/components/issue-row/issue-row.html',
        bindings: {
            issue: '<',
            /* Needed by the "open in Page Explorer" link of the detail. */
            projectId: '<',
            /* 'overview' keeps the wider summary used in the project overview. */
            variant: '@',
            /* Workspace helpers: resolved()/toggle() plus the renderers of the API
               texts and of the sample table cells. */
            hooks: '<'
        },
        controller: [function () {
            var ctrl = this;
            ctrl.resolved = function () { return !!(ctrl.hooks && ctrl.hooks.resolved(ctrl.issue)); };
            ctrl.toggle = function () { if (ctrl.hooks) ctrl.hooks.toggle(ctrl.issue); };
            ctrl.title = function (issue) { return ctrl.hooks && ctrl.hooks.title ? ctrl.hooks.title(issue) : (issue && issue.title) || ''; };
            ctrl.countLabel = function (issue) {
                return ctrl.hooks && ctrl.hooks.countLabel
                    ? ctrl.hooks.countLabel(issue)
                    : ((issue && issue.issues !== null && issue.issues !== undefined) ? issue.issues + ' issue' : '—');
            };
            ctrl.textualHtml = function (text) { return ctrl.hooks ? ctrl.hooks.textualHtml(text) : ''; };
            ctrl.cell = function (row, col) { return ctrl.hooks ? ctrl.hooks.cell(row, col) : ''; };
            ctrl.cellLink = function (row, col) { return ctrl.hooks ? ctrl.hooks.cellLink(row, col) : null; };
        }]
    };
});
